<mojo-lister entityName="ClientParent"
             [ownerEntityKey]="entityKey$ | async"
             (onRowSelect)="handleRowSelect($event)"
             [getRowHref]="getRowHref">
</mojo-lister>
